<template>
    <div class="form">
        <Row :gutter="20">
            <Col :span="roomId ? 16 : 24">
                <Tabs :animated="false" v-model="filter.unit" @on-click="tabsChange">
                    <TabPane
                        v-for="(item, index) in unitArr"
                        :key="index"
                        :label="item + '单元'"
                        :index="item"
                        :name="item + ''"
                    >
                        <Form :label-width="50" class="source-container">
                            <Row :gutter="20">
                                <Col span="24">
                                    <div style="line-height: 48px">
                                        <label class="source-top-title">楼层</label>
                                        <div class="source-room-item mini"></div>
                                        <label class="source-top-tip">待售</label>
                                        <div class="source-room-item mini warn"></div>
                                        <label class="source-top-tip">销控</label>
                                    </div>
                                    <FormItem
                                        v-for="(value, key) in roomData"
                                        :key="key"
                                        :label="key"
                                    >
                                        <div
                                            v-for="(item, index) in value"
                                            :class="item.houseStatus == '2'? 'warn': ''"
                                            :key="index"
                                            class="source-room-item"
                                            @click="checkRoom(item)"
                                        >
                                            <common-icon
                                                v-if="roomId == item.id"
                                                class="source-room-item-check"
                                                type="_dagou"
                                                color="#fb3b2c"
                                                :size="18"
                                            ></common-icon>
                                            {{item.roomNumber}}
                                        </div>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </TabPane>
                </Tabs>
            </Col>
            <Col v-if="roomId" :span="8">
                <room-info v-if="roomId" :info="roomInfo"></room-info>
            </Col>
        </Row>
    </div>
</template>
<script>
import { sourceList, sourceView } from '@/api/proj-manager'
import Dict from '@/utils/dict'
import RoomInfo from './room-info'
export default {
    name: 'FormFloorForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        },
        unitNum: {
            type: [String, Number],
            default: 1
        }
    },

    components: { RoomInfo },
    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            roomInfo: {
                roomNumber: '', //房号
                houseType: '', //户型
                roomLayout: '', //房间结构
                houseStatus: '', //销售状态
                leaseType: '', //租售类型
                buildArea: '', //建筑面积
                insideArea: '', //套内面积
                buildAveragePrice: '', //建筑单价
                insideAveragePrice: '', //套内单价
                standardPrice: '', //标准总价
                spikePrice: '' //秒杀总价
            },
            filter: {
                projId: '',
                floorId: this.id,
                unit: '1'
            },
            roomId: '',
            unitArr: [1],
            roomData: {}
        }
    },

    computed: {},

    methods: {
        fetch() {
            return sourceList(this.filter)
        },
        tabsChange() {
            this.roomId = ''
            this.fetch().then(args => {
                this.setData(args)
            })
        },
        setData(args) {
            let [room] = args
            this.roomData = (room.data.list || []).groupBy('layers')
        },
        checkRoom(item) {
            this.roomId = item.id
            this.getRoomInfo()
        },
        getRoomInfo() {
            sourceView(this.roomId).then(res => {
                Object.keys(this.roomInfo).forEach(key => {
                    this.roomInfo[key] = res.data[key]
                })
            })
        }
    },

    mounted() {
        var $info = this.$refs.info
        this.filter.projId = this.$route.params.id
        let unitArr = []
        for (let i = 1; i <= this.unitNum; i++) {
            unitArr.push(i)
        }
        this.unitArr = unitArr
        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([this.fetch()])
                .then(args => {
                    this.setData(args)
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    return genResources(formData)
                })
                .then(res => {
                    this.$Message.success(this.$t('tips.add.success'))
                })
                .catch(err => (options.closeModal = false))
                .finally(() => next())
        })
    }
}
</script>
<style lang="less"
    scoped>
@source-success: #4bd38a;
@source-warning: #ffa43d;
.source {
    &-container {
        height: 470px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            display: none;
        }
    }
    &-top {
        &-title {
            display: inline-block;
            width: 50px;
            text-align: center;
        }
        &-tip {
            margin: 0 20px 0 10px;
        }
    }
    &-room-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        width: 22%;
        margin-right: 20px;
        height: 32px;
        background-color: @source-success;
        text-align: center;
        margin-bottom: 5px;
        border-radius: 3px;
        &.mini {
            width: 42px;
            height: 24px;
            vertical-align: middle;
            margin: 0;
        }
        &.warn {
            background-color: @source-warning;
        }
        &-check {
            position: absolute;
            bottom: -1px;
            right: -1px;
        }
    }
}
</style>
